"use client";

import { create } from "zustand";
import { createCaseInfoSlice, CaseInfoState } from "./createCaseInfoSlice";
import { createGlobalSlice, GlobalState } from "./createGlobalSlice";
import {
  createPatientPathSlice,
  PatientPathState,
} from "./createPatientPathSlice";
import { ActionState, createActionSlice } from "./createActionSlice";
import {
  createPredefinedActionItemsSlice,
  PredefinedActionItemsState,
} from "./createPredefinedActionItemsSlice";
import { CarePlanState, createCarePlanSlice } from "./createCarePlanSlice";
import {
  createPatientEnrollmentSlice,
  PatientEnrollmentState,
} from "./createPatientEnrollmentSlice";
import { AuthState, createAuthSlice } from "./createAuthSlice";
import { AdminState, createAdminSlice } from "./createAdminSlice";
import {
  WorkflowAnalyticsState,
  createWorkflowAnalyticsSlice,
} from "./createWorkflowAnalyticsSlice";
import {
  TechniqueAnalyticsState,
  createTechniqueAnalyticsSlice,
} from "./createTechniqueAnalyticsSlice";

export type StoreState = CaseInfoState &
  GlobalState &
  PatientPathState &
  ActionState &
  PredefinedActionItemsState &
  CarePlanState &
  PatientEnrollmentState &
  AuthState &
  AdminState &
  WorkflowAnalyticsState &
  TechniqueAnalyticsState;
export const useBoundStore = create<StoreState>((...args) => ({
  ...createCaseInfoSlice(...args),
  ...createGlobalSlice(...args),
  ...createPatientPathSlice(...args),
  ...createActionSlice(...args),
  ...createPredefinedActionItemsSlice(...args),
  ...createCarePlanSlice(...args),
  ...createPatientEnrollmentSlice(...args),
  ...createAuthSlice(...args),
  ...createAdminSlice(...args),
  ...createWorkflowAnalyticsSlice(...args),
  ...createTechniqueAnalyticsSlice(...args),
}));
